import loadable from '@loadable/component'

export * from './SectionLayout'

export const SectionLayout = loadable(() => import('./SectionLayout'))
export type { SectionLayoutProps } from './SectionLayout'
